import ChangeRequestsService from '@/services/ChangeRequestsService';

let inFlightGetChangeRequests = null;
let inFlightGetChangeRequestsStatus = null;

export default {
  namespaced: true,

  state: {
    filterStatus: null,
    changeRequests: [],
    changeRequest: null,
    notificationItems: [],
    isLoadingNotificationItems: false,
    isLoadingChangeRequests: false,
  },

  getters: {
    changeRequests(state) {
      return state.changeRequests;
    },
    notificationItems(state) {
      return (authUserId) => {
        return (
          state.notificationItems.filter((cr) => {
            if (!cr.userActions || cr.userActions.length === 0) {
              return true;
            } else {
              const userAction = !!cr.userActions.find((ua) => ua.userId === authUserId);
              if (!userAction) {
                return true;
              } else {
                return false;
              }
            }
          }) || []
        );
      };
    },
    changeRequest(state) {
      return state.changeRequest;
    },
    isLoadingNotificationItems(state) {
      return state.isLoadingNotificationItems;
    },
    isLoadingChangeRequests(state) {
      return state.isLoadingChangeRequests;
    },
  },

  actions: {
    initialize({ commit }) {
      commit('setFilterStatus', null);
      commit('setChangeRequests', []);
      commit('setChangeRequest', null);
      commit('setNotificationItems', []);
      commit('setIsLoadingNotificationItems', false);
      commit('setIsLoadingChangeRequests', false);
    },

    getNotificationItems({ commit, rootGetters }) {
      return new Promise((resolve) => {
        commit('setIsLoadingNotificationItems', true);

        const authUser = rootGetters['auth/authUser'];
        const authUserRole = authUser.role;
        let status = '';

        if (authUserRole === 'Admin') {
          status = 'Submitted';
        } else if (authUserRole === 'Voter') {
          status = 'Pending';
        }

        if (status) {
          ChangeRequestsService.getChangeRequests(status)
            .then((data) => {
              commit('setNotificationItems', data);
            })
            .catch((error) => {
              console.error('getNotificationItems', error);
              commit('setNotificationItems', []);
            })
            .finally(() => {
              commit('setIsLoadingNotificationItems', false);
              resolve();
            });
        } else {
          commit('setNotificationItems', []);
          commit('setIsLoadingNotificationItems', false);
          resolve();
        }
      });
    },

    setFilterStatus({ commit }, status) {
      return new Promise((resolve) => {
        commit('setFilterStatus', status);
        resolve(status);
      });
    },

    getChangeRequests({ commit, dispatch, state }) {
      commit('setIsLoadingChangeRequests', true);

      const status = state.filterStatus;
      let mapStatus = status;
      switch (status) {
        case 'All':
          mapStatus = '';
          break;
      }
      const requestStatus = mapStatus || '__all__';

      if (inFlightGetChangeRequests) {
        if (inFlightGetChangeRequestsStatus === requestStatus) {
          return inFlightGetChangeRequests;
        }
        commit('setIsLoadingChangeRequests', false);
        return Promise.reject(new Error(`getChangeRequests already in-flight for status "${inFlightGetChangeRequestsStatus}"`));
      }

      inFlightGetChangeRequestsStatus = requestStatus;
      inFlightGetChangeRequests = ChangeRequestsService.getChangeRequests(mapStatus)
        .then((data) => {
          commit('setChangeRequests', data);
          dispatch('auth/refreshToken', null, { root: true });
          return data;
        })
        .finally(() => {
          commit('setIsLoadingChangeRequests', false);
          inFlightGetChangeRequests = null;
          inFlightGetChangeRequestsStatus = null;
        });

      return inFlightGetChangeRequests;
    },

    getChangeRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ChangeRequestsService.getChangeRequest(id)
          .then((data) => {
            commit('setChangeRequest', data);
            dispatch('auth/refreshToken', null, { root: true });
            resolve(data);
          })
          .catch((error) => {
            commit('setChangeRequest', null);
            reject(error);
          });
      });
    },

    clearChangeRequest({ commit }) {
      commit('setChangeRequest', null);
    },

    approveChangeRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ChangeRequestsService.approveChangeRequest(id)
          .then((data) => {
            dispatch('getChangeRequests');
            dispatch('getNotificationItems');
            commit('setChangeRequest', data);
            dispatch('auth/refreshToken', null, { root: true });
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    denyChangeRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ChangeRequestsService.denyChangeRequest(id)
          .then((data) => {
            dispatch('getChangeRequests');
            dispatch('getNotificationItems');
            commit('setChangeRequest', data);
            dispatch('auth/refreshToken', null, { root: true });
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    verifyChangeRequest({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ChangeRequestsService.verifyChangeRequest(id)
          .then((data) => {
            dispatch('getChangeRequests');
            dispatch('getNotificationItems');
            commit('setChangeRequest', data);
            dispatch('auth/refreshToken', null, { root: true });
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  mutations: {
    setFilterStatus(state, status) {
      state.filterStatus = status;
    },
    setChangeRequests(state, data) {
      state.changeRequests = data;
    },
    setChangeRequest(state, data) {
      state.changeRequest = data;
    },
    setNotificationItems(state, data) {
      state.notificationItems = data;
    },
    setIsLoadingNotificationItems(state, value) {
      state.isLoadingNotificationItems = !!value;
    },
    setIsLoadingChangeRequests(state, value) {
      state.isLoadingChangeRequests = !!value;
    },
  },
};
